<template>
  <v-dialog v-model="etiqueta" max-width="600px">
    <v-toolbar dark color="blue-grey">
      <v-toolbar-title>Etiquetas</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card class="pa-4 rounded-t-0">
      <v-row no-gutters class="pb-4">
        <span class="subtitle-2 grey--text text--darken-3">Selecciona la posición de impresión para la etiqueta.
        </span><strong class="subtitle-2 grey--text text--darken-4">(Recuerda colocar las etiquetas de manera correcta
          en la impresora).</strong>
      </v-row>
      <v-row no-gutters class="card mb-4">
        <v-col><v-card class="squares" hover :color="selected == 1 ? 'blue-grey lighten-2' : ''" :dark="selected == 1"
            :elevation="selected == 1 ? 8 : 2" @click="selected = 1"><span class="title">1</span></v-card>
        </v-col>
        <v-col><v-card class="squares" hover :color="selected == 2 ? 'blue-grey lighten-2' : ''" :dark="selected == 2"
            :elevation="selected == 2 ? 8 : 2" @click="selected = 2"><span class="title">2</span></v-card>
        </v-col>
      </v-row>
      <v-row no-gutters class="card mb-4">
        <v-col><v-card class="squares" hover :color="selected == 3 ? 'blue-grey lighten-2' : ''" :dark="selected == 3"
            :elevation="selected == 3 ? 8 : 2" @click="selected = 3"><span class="title">3</span></v-card>
        </v-col>
        <v-col><v-card class="squares" hover :color="selected == 4 ? 'blue-grey lighten-2' : ''" :dark="selected == 4"
            :elevation="selected == 4 ? 8 : 2" @click="selected = 4"><span class="title">4</span></v-card>
        </v-col>
      </v-row>
      <v-row no-gutters class="card mb-4">
        <v-col><v-card class="squares" hover :color="selected == 5 ? 'blue-grey lighten-2' : ''" :dark="selected == 5"
            :elevation="selected == 5 ? 8 : 2" @click="selected = 5"><span class="title">5</span></v-card>
        </v-col>
        <v-col><v-card class="squares" hover :color="selected == 6 ? 'blue-grey lighten-2' : ''" :dark="selected == 6"
            :elevation="selected == 6 ? 8 : 2" @click="selected = 6"><span class="title">6</span></v-card>
        </v-col>
      </v-row>
      <v-row no-gutters class="card mb-4">
        <v-col><v-card class="squares" hover :color="selected == 7 ? 'blue-grey lighten-2' : ''" :dark="selected == 7"
            :elevation="selected == 7 ? 8 : 2" @click="selected = 7"><span class="title">7</span></v-card>
        </v-col>
        <v-col><v-card class="squares" hover :color="selected == 8 ? 'blue-grey lighten-2' : ''" :dark="selected == 8"
            :elevation="selected == 8 ? 8 : 2" @click="selected = 8"><span class="title">8</span></v-card>
        </v-col>
      </v-row>
      <v-row no-gutters class="card mb-4">
        <v-col><v-card class="squares" hover :color="selected == 9 ? 'blue-grey lighten-2' : ''" :dark="selected == 9"
            :elevation="selected == 9 ? 8 : 2" @click="selected = 9"><span class="title">9</span></v-card>
        </v-col>
        <v-col><v-card class="squares" hover :color="selected == 10 ? 'blue-grey lighten-2' : ''" :dark="selected == 10"
            :elevation="selected == 10 ? 8 : 2" @click="selected = 10"><span class="title">10</span></v-card>
        </v-col>
      </v-row>
      <v-row no-gutters style="gap: .2rem;" justify="end">
        <v-btn color="blue-grey darken-1" dark @click="getEtiqueta()" :loading="loading">Aceptar</v-btn>
        <v-btn color="blue-grey darken-1" dark outlined @click="$emit('close')" :loading="loading">Cancelar</v-btn>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { getEtiquetaService } from './expediente.service';
export default {
  name: 'OficiosEtiquetas',
  props: {
    etiqueta: {
      type: Boolean,
    }
  },
  data() {
    return {
      selected: 1,
      loading: false
    };
  },

  mounted() {

  },

  methods: {
    async getEtiqueta() {
      this.loading = true;
      try {
        const etiqueta = await getEtiquetaService(this.$route.params.id, this.$route.params.tipo, this.selected);
        if (etiqueta.type != 'application/pdf') {
          const ServerResponse = JSON.parse(await etiqueta.text())
          this.$notificarError(ServerResponse.mensaje);
        }
        else {
          const url = window.URL.createObjectURL(etiqueta);
          window.open(url);
          this.$emit('close');
        }
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.squares {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card {
  gap: 1rem;
}
</style>